module.exports = __webpack_public_path__ + "static/media/dashboard_phone.48cf8ca6.png";